export default __webpack_public_path__ + "static/media/Group8868.182849db.svg";